import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NavigationControllerService } from '@personal-area/global/navigation-layout';

@Component({
  selector: 'pac-trader-header',
  templateUrl: './trader-header.component.html',
  styleUrls: ['./trader-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, AsyncPipe, NgIf, NgTemplateOutlet, RouterLink],
})
export class TraderHeaderComponent {
  public sidebarVisible$ = this._controller.sidebarVisible;

  constructor(
    private _controller: NavigationControllerService,
  ) { }

  public showSidebar = () => this._controller.showSidebar();
  public hideSidebar = () => this._controller.hideSidebar();
}
